import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component, Inject,
  Input,
  OnDestroy,
  OnInit, PLATFORM_ID,
  ViewChild
} from '@angular/core';
import { componentDestroyed, Game, handleError, LeagueCourt, UntilDestroy } from '@mtgame/core';
import { LeagueGamesSliderService } from './league-games-slider.service';
import { takeUntil } from 'rxjs/operators';
import { DataSliderComponent } from '@mtgame/ui';
import { isPlatformBrowser } from '@angular/common';

@UntilDestroy
@Component({
  selector: 'mtg-league-games-slider',
  templateUrl: './league-games-slider.component.html',
  styleUrls: [
    '../shared/styles.scss',
    './league-games-slider.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    LeagueGamesSliderService
  ]
})
export class LeagueGamesSliderComponent implements OnInit, OnDestroy {
  @Input()
  leagueId: number;
  @Input()
  seasonId: number;
  @Input()
  court: LeagueCourt;
  @Input()
  title: string;
  games: Game[];
  loading: boolean;
  @ViewChild('dataSliderComponent', {read: DataSliderComponent})
  dataSliderComponent: DataSliderComponent;
  isBrowser = isPlatformBrowser(this.platformId);

  constructor(
    @Inject(PLATFORM_ID) private platformId: string,
    private leagueGamesSliderService: LeagueGamesSliderService,
    private cdr: ChangeDetectorRef,
  ) {
  }

  ngOnInit(): void {
    if (!this.isBrowser) {
      return;
    }
    this.leagueGamesSliderService.initialize(this.leagueId, {
      tournamentCourtId: this.court && this.court.id,
      tournamentSeasonId: this.seasonId
    });
    this.leagueGamesSliderService.games$
      .pipe(takeUntil((componentDestroyed(this))))
      .subscribe(games => {
        this.games = games;
        this.cdr.markForCheck();
      });
  }

  ngOnDestroy(): void {
  }

  slideLeft(): void {
    if (this.dataSliderComponent) {
      this.dataSliderComponent.slideLeft();
    }
  }

  slideRight(): void {
    if (this.dataSliderComponent) {
      this.dataSliderComponent.slideRight();
    }
  }

  async loadNextPage(): Promise<void> {
    this.loading = true;
    setTimeout(() => {
      this.cdr.markForCheck();
    });
    try {
      await this.leagueGamesSliderService.loadNextPage();
      this.loading = false;
    } catch (e) {
      handleError(e);
    }
  }
}
